import { Compass, Home, Sparkles, Sprout, HandHeart } from "lucide-react";
import { IMG } from "@/lib/content";

export const MENUS = {
  new: [
    { label: "Welcome", href: "/" },
    { label: "Worship Services", href: "/worship" },
    { label: "Get Connected", href: "/connect" },
  ],
  member: [
    { label: "Welcome Home", href: "/" },
    { label: "Worship Services", href: "/worship" },
    { label: "Events", href: "/events" },
    { label: "Communities", href: "/communities" },
    { label: "Discipleship", children: [
      { label: "Make Disciples", href: "/discipleship/make-disciples" },
      { label: "I Want to be Discipled", href: "/discipleship/be-discipled" },
    ] },
    { label: "Journey", href: "/journey" },
    { label: "Pastoral Care Services", href: "/pastoral-care" },
  ],
};

export const DEFAULT_EXPERIENCE = {
  order: ["devotional", "visit", "jesus", "groups", "serve", "events"],
};

export const INTENTS = [
  {
    id: "browsing", icon: Compass, color: "#1D64B4", short: "Just browsing",
    label: "Just browsing, God must've led me here for a purpose",
    sub: "Curious about who we are and what a Sunday looks like.",
    audience: "new",
    order: ["visit", "devotional", "events", "jesus", "groups", "serve"],
    steps: [
      { title: "What to expect on a Sunday", text: "Service times and a warm welcome waiting for you.", href: "/worship", img: IMG.stage },
      { title: "Watch a 2-minute devotional", text: "A short word from our pastors — perfect for a first taste.", href: "/devotionals", img: IMG.speaker },
      { title: "See what's coming up", text: "Upcoming gatherings and celebrations you can join.", href: "#events", img: IMG.praise },
    ],
  },
  {
    id: "looking_for_church", icon: Home, color: "#0A3A6B", short: "Looking for a church home",
    label: "I'm a new Christian looking for a Home Church",
    sub: "Ready to plant roots in a church family in Parañaque.",
    audience: "new",
    order: ["visit", "groups", "serve", "devotional", "events", "jesus"],
    steps: [
      { title: "Plan your first Sunday", text: "Let us know you're coming and we'll be ready to welcome you.", action: "plan_visit", img: IMG.stage },
      { title: "Join a Victory Group", text: "Small groups where friends grow in faith together.", action: "victory_group", img: IMG.group },
      { title: "Meet a pastor", text: "A pastor would be glad to get to know you personally.", action: "talk_pastor", img: IMG.speaker },
    ],
  },
  {
    id: "seeking_jesus", icon: Sparkles, color: "#D97706", short: "Seeking Jesus",
    label: "I want to know Jesus and be part of His family",
    sub: "Exploring faith, asking questions, looking for hope.",
    audience: "new",
    order: ["jesus", "devotional", "visit", "groups", "events", "serve"],
    steps: [
      { title: "Who is Jesus?", text: "A simple, honest introduction to the good news.", href: "#jesus", img: IMG.bible },
      { title: "Talk with someone", text: "A pastor or leader would love to listen and pray with you.", action: "talk_pastor", img: IMG.group },
      { title: "Start with 2 minutes a day", text: "Short daily devotionals to begin your walk with God.", href: "/devotionals", img: IMG.speaker },
    ],
  },
  {
    id: "grow", icon: Sprout, color: "#6D28D9", short: "Growing deeper",
    label: "I already attend and want to grow deeper",
    sub: "Victory Groups or the Discipleship Journey course.",
    audience: "member",
    order: ["groups", "devotional", "events", "serve", "visit", "jesus"],
    steps: [
      { title: "Join a Victory Group", text: "We'll gladly help you find a group near you.", action: "victory_group", img: IMG.group },
      { title: "Discipleship Journey", text: "The Church's step-by-step course for growing disciples.", href: "/journey", img: IMG.bible },
      { title: "Daily devotionals", text: "Two minutes with God every day from our pastors and leaders.", href: "/devotionals", img: IMG.speaker },
    ],
  },
  {
    id: "serve", icon: HandHeart, color: "#059669", short: "Ready to serve",
    label: "I want to serve and join a ministry",
    sub: "Use your gifts to honour God and serve people.",
    audience: "member",
    order: ["serve", "events", "groups", "devotional", "visit", "jesus"],
    steps: [
      { title: "Explore ministries", text: "Meet the teams serving God and people every week.", href: "#serve", img: IMG.youth },
      { title: "Find where you'd love to serve", text: "Share your heart to serve and a ministry leader will gladly reach out.", action: "serve", img: IMG.praise },
      { title: "Upcoming events", text: "Gatherings and celebrations where you can serve alongside us.", href: "/events", img: IMG.stage },
    ],
  },
];

export const intentById = (id) => INTENTS.find((i) => i.id === id);
export const audienceOf = (id) => intentById(id)?.audience || "new";
